import(/* webpackMode: "eager" */ "/home/thescribebank-adminpanel-testing/htdocs/adminpanel-testing.thescribebank.com/app/global-error.tsx");
